const RESOURCES = [
  {
    label: "GUIDE",
    title: "Read your first packet capture",
    desc: "A 20-minute walkthrough of a real Wireshark capture, from three-way handshake to spotting the odd DNS request.",
  },
  {
    label: "FREE LABS",
    title: "Ten starter range labs",
    desc: "Scanning, enumeration and log triage on the same range the paid track uses. No card, no install.",
  },
  {
    label: "INTERVIEW PREP",
    title: "120 SOC interview questions",
    desc: "The questions hiring managers actually ask Tier 1 candidates, with the reasoning they want to hear.",
  },
];

export default function FreeResourcesSection() {
  return (
    <section className="border-t border-[#18181b] bg-[#050505]">
      <div className="max-w-[1200px] mx-auto px-6 py-10 sm:py-20">
        <div className="flex justify-between items-end gap-3 sm:gap-6 flex-wrap mb-9">
          <div>
            <div
              className="font-mono text-[12px] text-[#71717a] mb-[18px]"
              style={{ letterSpacing: "0.18em" }}
            >
              09 — START BEFORE YOU PAY
            </div>
            <h2
              className="font-bold text-white"
              style={{
                fontSize: "clamp(28px, 3.2vw, 40px)",
                lineHeight: 1.06,
                letterSpacing: "-0.03em",
              }}
            >
              Free resources
            </h2>
          </div>
          <button
            type="button"
            className="text-[15px] text-[#a1a1aa] border-b border-[#3f3f46] pb-[3px] hover:text-white transition-colors cursor-pointer bg-transparent font-[inherit]"
          >
            Browse everything →
          </button>
        </div>
        <div className="grid grid-cols-[repeat(auto-fit,minmax(260px,1fr))] gap-5">
          {RESOURCES.map((r, i) => (
            <div
              key={i}
              className="border border-[#27272a] rounded-xl p-[26px] bg-black block hover:border-[#52525b] hover:text-white transition-colors"
            >
              <div
                className="font-mono text-[11px] text-[#a3e635] mb-3.5"
                style={{ letterSpacing: "0.12em" }}
              >
                {r.label}
              </div>
              <div
                className="text-[16px] sm:text-[19px] font-semibold mb-2.5"
                style={{ letterSpacing: "-0.01em" }}
              >
                {r.title}
              </div>
              <div className="text-[14px] text-[#a1a1aa] leading-relaxed">
                {r.desc}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
